<!--左侧菜单-->
<template>
  <ul class="menu-nav">
    <template v-for="item in leftMenu">
      <template v-if="!item.children&&!item.display">
        <router-link
          :to="item.path"
          v-slot="{ href, navigate, isActive, isExactActive }"
          :key="item.id"
        >
          <li
            aria-haspopup="true"
            data-menu-toggle="hover"
            class="menu-item"
            :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
          >
            <a :href="href" class="menu-link" @click="navigate" style="align-items: center;">
              <b-icon :icon="item.icon"></b-icon>
              <!-- <i class="menu-icon flaticon2-architecture-and-city"></i> -->
              <span class="menu-text">{{item.name}}</span>
            </a>
          </li>
        </router-link>
      </template>
      <template v-else-if="!item.display">
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item menu-item-submenu"
          v-bind:class="{ 'menu-item-open': hasActiveChildren('vuetify') }"
          :key="item.id"
        >
          <a href="#" class="menu-link menu-toggle" style="align-items: center;">
            <!-- <i class="menu-icon flaticon-web"></i> -->
            <b-icon :icon="item.icon" class="menu-icon"></b-icon>
            <span class="menu-text">{{item.name}}</span>
            <i class="menu-arrow"></i>
          </a>
          <div class="menu-submenu" style="display: none; overflow: hidden;">
            <span class="menu-arrow"></span>
            <ul class="menu-subnav">
              <li aria-haspopup="true" class="menu-item menu-item-parent">
                <span class="menu-link">
                  <span class="menu-text">{{item.name}}</span>
                </span>
              </li>
              <template v-for="menu in item.children">
                <router-link
                  :to="`/${item.url}/${menu.url}`"
                  v-slot="{ href, navigate, isActive, isExactActive }"
                  :key="menu.id"
                >
                  <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
                  >
                    <a :href="href" class="menu-link" @click="navigate">
                      <i class="menu-bullet menu-bullet-dot">
                        <span></span>
                      </i>
                      <span class="menu-text">{{menu.name}}</span>
                    </a>
                  </li>
                </router-link>
              </template>
            </ul>
          </div>
        </li>
      </template>
    </template>
  </ul>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "KTMenu",
  watch: {
    menu(o) {
      this.setLeftMenu(o);
    },
  },
  data() {
    return {
      leftMenu: [],
    };
  },
  created() {
    this.setLeftMenu();
  },
  methods: {
    setLeftMenu() {
      this.leftMenu = this.menu;
    },
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    },
  },
  computed: {
    ...mapState({
      menu: (state) => state.auth.leftMenu,
    }),
  },
};
</script>
